(function () {
    var windowAsAny = window;
    // Cross-browser polyfill for Element closest() and match()
    var ElementPrototype = windowAsAny.Element.prototype;
    if (typeof ElementPrototype.matches !== "function") {
        ElementPrototype.matches =
            ElementPrototype.msMatchesSelector ||
                ElementPrototype.mozMatchesSelector ||
                ElementPrototype.webkitMatchesSelector ||
                function matches(selector) {
                    // tslint:disable-next-line:no-this-assignment
                    var element = this;
                    var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
                    var index = 0;
                    while (elements[index] && elements[index] !== element) {
                        ++index;
                    }
                    return Boolean(elements[index]);
                };
    }
    if (typeof ElementPrototype.closest !== "function") {
        ElementPrototype.closest = function closest(selector) {
            // tslint:disable-next-line:no-this-assignment
            var element = this;
            while (element && element.nodeType === 1) {
                if (element.matches(selector)) {
                    return element;
                }
                element = element.parentNode;
            }
            return null;
        };
    }
    // CustomEvent() polyfill
    if (typeof windowAsAny.CustomEvent !== "function") {
        var CustomEvent_1 = function (event, argParams) {
            var params = argParams || {
                bubbles: false,
                cancelable: false,
                detail: null
            };
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        };
        windowAsAny.CustomEvent = CustomEvent_1;
    }
})();
//# sourceMappingURL=polyfill.js.map